import { createStore } from 'effector'
import { PlatformConnected, PlatformType } from './types'
import { useUnit } from 'effector-react'
import { egsRouter, steamRouter } from '@/shared/util/platformRouter'

import { getUserProfileFx } from '@/entities/user'

const $steam = createStore<PlatformType>({
  name: 'Steam',
  status: 'Available',
  icon: 'https://storage.yandexcloud.net/gamed/platform/steam.webp',
  onClick: () => {
    steamRouter('Available')
  },
}).on(getUserProfileFx.doneData, (state, data) =>
  data?.user?.steam_id ? { ...state, status: 'Connected', onClick: () => steamRouter('Connected') } : state
)

const $epic = createStore<PlatformType>({
  name: 'Epic Games',
  status: 'Available',
  icon: 'https://storage.yandexcloud.net/gamed/platform/egs.webp',
  onClick: () => {
    egsRouter('Available')
  },
}).on(getUserProfileFx.doneData, (state, data) => {
  return data?.user.epic_id ? { ...state, status: 'Connected', onClick: () => egsRouter('Connected') } : state
})

const $faceit = createStore<PlatformType>({
  name: 'Faceit',
  status: 'Soon',
  icon: 'https://storage.yandexcloud.net/gamed/platform/faceit.webp',
  onClick: () => {},
})

const $psn = createStore<PlatformType>({
  name: 'PlayStation Store',
  status: 'Soon',
  icon: 'https://storage.yandexcloud.net/gamed/platform/psn.webp',
  onClick: () => {},
})

const $xbox = createStore<PlatformType>({
  name: 'Xbox',
  status: 'Soon',
  icon: 'https://storage.yandexcloud.net/gamed/platform/xbox.webp',
  onClick: () => {},
})

const $appstore = createStore<PlatformType>({
  name: 'App Store',
  status: 'Soon',
  icon: 'https://storage.yandexcloud.net/gamed/platform/appstore.webp',
  onClick: () => {},
})

const $googleplay = createStore<PlatformType>({
  name: 'Google Play',
  status: 'Soon',
  icon: 'https://storage.yandexcloud.net/gamed/platform/googleplay.webp',
  onClick: () => {},
})

const $mock = createStore<PlatformType>({
  name: 'Mock',
  status: 'Available',
  icon: '/assets/social/mock.webp',
  onClick: () => {},
  isMock: true,
})

const usePlatformsList = () => {
  const platformsList = useUnit([$steam, $epic, $psn, $xbox, $appstore, $googleplay, $faceit, $mock])
  return platformsList
}

export const $isPlatformConnected = createStore<PlatformConnected>({
  farcana: false,
  steam: false,
}).on(getUserProfileFx.doneData, (state, data) => {
  const newState = { ...state }
  if (data.user?.steam_id) {
    newState.steam = true
  }

  if (data?.settings?.farcana_jwt) {
    newState.farcana = true
  }

  return newState
})

export { $steam, $epic, $faceit, $psn, usePlatformsList }
